import React from 'react';
import styles from './commentary_list.module.scss';
import { HybridCommentaryCard } from '../card/HybridCommentaryCard';
import { Commentary } from '../commentary.types';

type Props = {
  commentary: Commentary;
  onCommentaryClicked: Function;
  source: string;
};

export const CommentaryListHybridCommentary: React.FC<Props> = (props) => (
  <HybridCommentaryCard
    {...props}
    className={`${styles.commentaryItem} ${styles.pointer}`}
  />
);
